export default "__VITE_ASSET__BEwBeHoM__"